import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useAuthState, isAuthenticated } from '../../components/AuthContextProvider';
import { OktaLoginWidget } from '../../auth';

const Login: React.FC = () => {
    const location: any = useLocation();
    const authState = useAuthState();

    if (isAuthenticated(authState)) {
        const { from } =
            location && location.state && 'from' in location.state
                ? location.state
                : { from: { pathname: '/' } };
        return <Redirect to={from} />;
    }

    return <OktaLoginWidget />;
};

export { Login };
